// src/components/Admin/Scenes/SceneIframe.jsx (o InfoSalaCmp.jsx)
import React, { useEffect, useState, useCallback } from "react";
import { Loader, Message } from "semantic-ui-react";
import { DidacticRoutesAPI } from "../../../../api";
import { Module2 } from "../../../Admin/GuiaCmp";
import "./InfoSalaCmp.scss"; // <-- Importamos el nuevo SCSS

const didacticRoutesAPI = new DidacticRoutesAPI();

export function InfoSalaCmp({ routeId, accessToken }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [scene, setSceneData] = useState(null); // Datos de la escena activa

  const loadSala = useCallback(async () => {
    if (!routeId) return;
    try {
      setLoading(true);
      setError(null);

      // 1) Obtener la ruta didáctica por ID
      const routeResult = await didacticRoutesAPI.getRouteById(accessToken, routeId);
      const route = routeResult.route;

      if (!route) {
        setError("Ruta no encontrada");
        return;
      }

      console.log("Ruta:", route.sceneactive, " id ", route.sceneactive_Id);
      setSceneData(route);
    } catch (err) {
      console.error(err);
      setError(err.message || "Error desconocido");
    } finally {
      setLoading(false);
    }
  }, [accessToken, routeId]);

  useEffect(() => {
    if (routeId) {
      loadSala();
    }
  }, [routeId, loadSala]);

  // Si no hay routeId
  if (!routeId) {
    return (
      <div style={{ textAlign: "center", padding: "2rem" }}>
        <p>No hay escena activa</p>
      </div>
    );
  }

  if (loading) {
    return <Loader active inline="centered">Cargando sala...</Loader>;
  }

  if (error) {
    return (
      <Message negative>
        <Message.Header>Error</Message.Header>
        <p>{error}</p>
      </Message>
    );
  }

  if (!scene) {
    return <p>No se pudo cargar la información de la sala.</p>;
  }

  return (
    // Envolvemos el contenido en un div con la clase .info-sala-cmp
    <div className="info-sala-cmp">
      {/* Muestra solo la columna izquierda de Module2 */}
      <Module2 refId={scene.sceneactive_Id} onlyLeftColumn />
    </div>
  );
}
